// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — Rack.classic.js, новая — Rack.cp.js
import { isCp } from 'libs/design';
import * as classic from './Rack.classic';
import * as cp from './Rack.cp';

export default isCp ? cp.default : classic.default;
